// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_CurrentInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_CurrentInput — body for POST /subscriptions/terms/current.
 *
 * Both ids are explicit rather than inferred. A user may hold BILLING_SELF for
 * several franchises, and the agreement they must read is the one attached to
 * the PLAN they are about to subscribe — so the caller names both.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_CurrentInput {
franquia_id: number
plan_id: number
}

registerContract('SubscriptionTerms_CurrentInput', {
  franquia_id: { type: 'number',  required: true },
  plan_id:     { type: 'number',  required: true },
})
